// extracted by mini-css-extract-plugin
export default {"switcher":"AssociationSwitcher_switcher__xpt76","label":"AssociationSwitcher_label__e90wr","select":"AssociationSwitcher_select__s6AJU"};